export default {
  headline: 'Te damos la bienvenida',
  welcomeText: process.env.HAWKEYE_APP_WELCOME_TEXT_ES ||
  'al sistema de gestión del aprendizaje de innovation mecom.'
}
